import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_proxy = (id) => {
  return api.post(`${ApiEndpointConstants.DELETPROXY}`, {}, { params: { id } });
};
